import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "items", "disabled", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getMenuItems from '../menuItems/getMenuItems';
import menuItemsPropTypes from './menuItemsPropTypes';
import MenuItems from '../menuItems/MenuItems';
var DropdownSubmenu = function DropdownSubmenu(props) {
  var title = props.title,
    items = props.items,
    disabled = props.disabled,
    className = props.className,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('dropdown-submenu', disabled && 'disabled', className && className);
  return /*#__PURE__*/React.createElement("li", _extends({}, remainingProps, {
    className: classes
  }), /*#__PURE__*/React.createElement("a", {
    className: "submenu-title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "submenu-title-text"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-menu-right"
  })), /*#__PURE__*/React.createElement(MenuItems, null, getMenuItems(items)));
};
DropdownSubmenu.defaultProps = {
  title: '',
  items: [],
  disabled: false
};
DropdownSubmenu.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  items: menuItemsPropTypes,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default DropdownSubmenu;